import { createHelper } from '@/client/features/issue/utils/helper';
import Markdown from '@/components/content/markdown/Markdown';
import { formatIsoDate } from '@/utils/date';
import { ArticleItem, EventEntity } from '@/client/features/events/types';
import { buildIdNameObject, dedupeByField, getEntries } from '@/utils';
import RiskIndicators from '@/client/features/riskindicators/RiskIndicators';
import EventRelationships from '@/client/features/events/components/EventRelationships';

const helper = createHelper<EventEntity>();

export const left = [
  {
    title: 'Summary',
    submodules: [
      helper.accessor((data) => data.summary, {
        title: 'Description',
        element: ({ getValue }) => <Markdown text={getValue()} />,
        scroll: false,
      }),
    ],
  },
  {
    submodules: [
      helper.accessor((data) => data.articles, {
        element: ({ getValue }) => <EventRelationships articles={getValue()} />,
        scroll: false,
      }),
    ],
  },
];

export const right = [
  {
    submodules: [
      helper.accessor(
        (data) => ({
          locations: getEntries(
            buildIdNameObject(data.catalog.country_id, data.catalog.country)
          ).map(([id, name]) => ({
            id,
            name,
          })),
          technologies: getEntries(
            buildIdNameObject(data.catalog.technology_id, data.catalog.technology)
          ).map(([id, name]) => ({ id, name })),
          industry_sectors: getEntries(
            buildIdNameObject(data.catalog.industrysector_id, data.catalog.industrysector)
          ).map(([id, name]) => ({ id, name })),
        }),
        {
          title: 'Your Relevancy',
          element: RiskIndicators,
          scroll: false,
        }
      ),
    ],
  },
  {
    submodules: [
      helper.accessor((data) => data.id, {
        title: 'ID',
      }),
      helper.accessor((data) => data.category, {
        title: 'Category',
        element: ({ getValue, id }) => getValue()[0],
      }),
      helper.accessor((data) => data.centroidEventTimestamp, {
        title: 'Occurrence date',
        element: ({ getValue }) => formatIsoDate(getValue()),
      }),
      helper.accessor((data) => data.firstSeen, {
        title: 'First Seen',
        element: ({ getValue }) => formatIsoDate(getValue()),
      }),
      helper.accessor((data) => data.lastSeen, {
        title: 'Last Seen',
        element: ({ getValue }) => formatIsoDate(getValue()),
      }),
      helper.accessor(
        (data) => dedupeByField('signal_id', (data.articles ?? []) as ArticleItem[]).length,
        {
          title: 'Total Signals',
        }
      ),
      helper.accessor((data) => data.totalSources, {
        title: 'Total Sources',
      }),
    ],
  },
];
